import React from 'react';
import Logout from '../features/auth/Components/Logout';

function LogoutPage() {
    document.title = "Logout";
    return (
        <Logout />
    )
}

export default LogoutPage